/**
 * Code highlighting
 * @requires https://highlightjs.org/
 */

(function() {
  function initCodeHighlight() {
    document.querySelectorAll('.code-highlight code').forEach((el) => {
      const languageClass = Array.from(el.classList).find((cls) => cls.startsWith('language-'))
      const language = languageClass ? languageClass.split('-')[1] : null

      if (language && typeof hljs !== 'undefined') {
        hljs.configure({ ignoreUnescapedHTML: true, languages: [language] })
        hljs.highlightElement(el)
      }
    })

    // Copy-to-clipboard
    const buttons = document.querySelectorAll('[data-copy-code]')
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const codeBlockId = button.getAttribute('data-copy-code').substring(1)
        const codeBlock = document.getElementById(codeBlockId)
        if (codeBlock) {
          const codeText = codeBlock.textContent || codeBlock.innerText
          navigator.clipboard
            .writeText(codeText)
            .then(() => {
              button.classList.remove('btn-outline-secondary')
              button.classList.add('btn-outline-success', 'text-success')
              button.innerHTML = '<i class="ci-check fs-sm me-1"></i> Copied'
            })
            .catch((err) => console.error('Error copying code:', err))
        }
      })
    })
  }

  document.addEventListener('turbo:load', initCodeHighlight)
})()
